export const patternCategories = [
	{ label: 'All', name: 'all' },
	{ label: 'Countdown', name: 'countdown' },
	{ label: 'Slider', name: 'slider' },
	{ label: 'CTA', name: 'cta' }
];

export const pageCategories = [
	{ label: 'All', name: 'all' }
];